function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.60268 0.059539C6.57219 0.0220052 6.52551 0 6.47626 0L2.17009 0C2.09573 0 2.03111 0.0493167 2.01365 0.11939L1.83629 0.830659C1.8247 0.877166 1.83573 0.926249 1.86631 0.963861C1.89681 1.00139 1.9434 1.0234 1.99273 1.0234H3.50583L2.12172 6.61296H0.700198C0.625843 6.61296 0.561224 6.66236 0.543762 6.73228L0.366323 7.44354C0.354735 7.49013 0.36576 7.53921 0.396339 7.57675C0.426837 7.61428 0.47343 7.63636 0.522759 7.63636H4.82894C4.90329 7.63636 4.96791 7.58697 4.98529 7.51697L5.16265 6.80578C5.17424 6.7592 5.16321 6.71011 5.13264 6.67258C5.10214 6.63505 5.05554 6.61296 5.00622 6.61296H3.51573L4.89975 1.0234H6.29874C6.3731 1.0234 6.43772 0.974083 6.4551 0.904087L6.63254 0.192819C6.64421 0.146233 6.63318 0.0971508 6.60268 0.059539Z"
});

function SvgItalicicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicicon);
export default __webpack_public_path__ + "static/media/italic.icon.d44499b2.svg";
export { ForwardRef as ReactComponent };